/**
 * Çekilişin oyuncuya dönük saf hesapları.
 *
 * Sayfadan ayrı durur çünkü kalan süre ve ilerleme metni iki yerde birden
 * gerekir (çekiliş sayfası ve promosyon kartı) ve iki kopya ayrışırsa aynı
 * çekiliş iki ekranda iki farklı süre söylerdi.
 */

/** Kalan süre — gün/saat ayrıntısı oyuncunun sorduğu tek şeydir. */
export const remainingText = (endsAt, now = Date.now()) => {
  if (!endsAt) return '';
  const target = new Date(endsAt).getTime();
  if (Number.isNaN(target)) return '';
  const diff = target - now;
  // Geçmiş tarihte geri sayım çizilmez: negatif bir süre oyuncuya hâlâ
  // bilet kazanabileceğini düşündürürdü.
  if (diff <= 0) return 'Süre doldu';
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  if (days > 0) return `${days} gün ${hours} saat kaldı`;
  if (hours > 0) return `${hours} saat ${minutes} dakika kaldı`;
  return `${minutes} dakika kaldı`;
};

/**
 * Bir sonraki bilete ne kadar yaklaşıldığı (0–100).
 *
 * Ölçü ``next_ticket_in`` üzerinden tersten okunur: uç, oyuncunun bir
 * sonraki bilet için yatırması gereken tutarı bildirir.
 */
export const ticketProgress = (me) => {
  const unit = Number(me?.ticket_amount || 0);
  if (!unit) return 0;
  const remaining = Math.max(0, Number(me?.next_ticket_in || 0));
  const filled = unit - remaining;
  return Math.max(0, Math.min(100, (filled / unit) * 100));
};
